<script lang="ts">
  // Continuity module, Phase 4 — the admin home (spec 5.1): three counts,
  // nothing else above the fold, plus the monthly proof-test pick.
  import { createQuery, useQueryClient } from '@tanstack/svelte-query';
  import { continuityHomeApi } from '$lib/api/continuityHome';
  import { getErrorMessage } from '$lib/api/client';
  import { toast } from '$lib/state/toast.svelte';

  const {
    onGoOKRs,
    onGoPeople,
    onStarted
  }: {
    onGoOKRs: (filter: 'red' | 'never_proven') => void;
    onGoPeople: () => void;
    onStarted: (okrId: number) => void;
  } = $props();

  const queryClient = useQueryClient();
  const query = createQuery(() => ({ queryKey: ['continuity-home'], queryFn: () => continuityHomeApi.get() }));

  let starting = $state(false);

  async function start(okrId: number) {
    starting = true;
    try {
      const res = await continuityHomeApi.startProofTest(okrId);
      queryClient.invalidateQueries({ queryKey: ['continuity-home'] });
      onStarted(res.okr_id);
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      starting = false;
    }
  }
</script>

<div class="tym-page">
  {#if query.isLoading}
    <div class="tym-loading-state">Loading...</div>
  {:else if query.isError}
    <div class="tym-error-state">Could not load the Continuity home.</div>
  {:else if query.data}
    {@const home = query.data}
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
      <button type="button" class="tym-card p-5 text-left" onclick={() => onGoOKRs('red')}>
        <p class="text-[13px] font-semibold text-dark-gray">OKRs only one person can do</p>
        <p class="mt-1 tym-stat-value text-4xl">{home.okrs_only_one_person_can_do}</p>
      </button>
      <button type="button" class="tym-card p-5 text-left" onclick={() => onGoOKRs('never_proven')}>
        <p class="text-[13px] font-semibold text-dark-gray">OKRs never proven</p>
        <p class="mt-1 tym-stat-value text-4xl">{home.okrs_never_proven}</p>
      </button>
      <button type="button" class="tym-card p-5 text-left" onclick={onGoPeople}>
        <p class="text-[13px] font-semibold text-dark-gray">People overdue a conversation</p>
        <p class="mt-1 tym-stat-value text-4xl">{home.people_overdue_conversation}</p>
      </button>
    </div>

    {#if home.proof_test_pick}
      <div class="mt-5 flex flex-wrap items-center gap-3">
        <p class="text-[13px] text-toyama-heavy-carbon">
          This month's proof test: <span class="font-semibold text-navy">{home.proof_test_pick.okr_name}</span>
        </p>
        <button type="button" class="btn-primary" disabled={starting} onclick={() => start(home.proof_test_pick!.okr_id)}>
          {starting ? 'Starting...' : 'Start'}
        </button>
      </div>
    {/if}
  {/if}
</div>
